import { SubGrupoCiclo } from './../veiculo/shared/model/sub-grupo-ciclo.model';
import { ComunicacaoService } from './../../shared/services/comunicacao.service';
import { StringMapWithRename } from '@angular/compiler/src/compiler_facade_interface';
import { Component, OnInit } from '@angular/core';
import { OrcamentoService } from '../../shared/services/orcamento.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, RequiredValidator, Validators } from '@angular/forms';
import { RestService } from '../../shared/services/rest.service';
import { SessionService } from '../../shared/services/session.service';
import { UpperCasePipe } from '@angular/common';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-atribuicao',
  templateUrl: './atribuicao.component.html',
  styleUrls: ['./atribuicao.component.css']
})
export class AtribuicaoComponent implements OnInit {
  uuidEmpOrcamento: string;
  uuidEmpResp: string;
  resourceForm: FormGroup;
  uuid: string;
  responsaveis: Array<any> = [];
  nomeEmpResp: string;
  responsavel: any;
  tipoEmpResp: string;
  isReadOnly: boolean = false;
  protocolo: string;
  atribuicaonome: string;
  uuid_oficina: string;
  empresas: Array<any>;
  habilitaTipo: boolean = true;
  empresaSelecionada: string = 'Empresa';
  tipo_empresa: any;
  usu_resp_atri: any = null;
  empresaAtribuida: any = null;
  empresaAtribuidaTipo: any = null;
  valores: Array<any> = [];
  temReguladora: boolean = false;
  status: Array<any> = [null, null, null];
  versao: any = null;
  versao_visual: any = null;
  //pecas: Array<any> = [];
  constructor(
    private formBuilder: FormBuilder,
    private rest: OrcamentoService,
    public bsModalRef: BsModalRef,
    public serv: RestService,
    private sessionService: SessionService,
    private info: MessageService,
    private comu: ComunicacaoService
  ) { }

  ngOnInit(): void {
    this.resourceForm = this.formBuilder.group({
      usuario: [null, Validators.required],
      usuarioEmpresa: [null, Validators.required],
      empresa_resp: [null, Validators.required],
      resp_orcamento: [null, Validators.required],
      protocolo: [null,]
    });

    this.tipo_empresa = this.sessionService.getTipoEmpresa();
    this.nomeEmpResp = this.sessionService.getCurrentRazaoSocial();
    this.tipoEmpResp = this.sessionService.getTipoEmpresa();
    this.uuidEmpResp = this.sessionService.getUUIDEmpresa();
    this.getTipoEmpresaAtual()
    this.getDados()
  }
  getDados() {//2023030600001
    this.rest.getOrcamentoProtocol(this.protocolo).subscribe((data: any) => {
      let dados = data.data[0];
      this.versao = dados.versao;
      this.versao_visual = dados.versao_visual;
      this.temReguladora = (dados.id_reguladora ? true : false);//esse parametro pode ser usado posteriormente no momento de salvar o novo status do orçamento
      this.status[0] = dados.status;
      this.status[1] = dados.status_atribuido;
      this.status[2] = dados.status_atribuido_2;
      //obtem os dados para realizar a atribuição posteriormente
      this.uuid = dados.uuid;//uuid do orçamento
      this.usu_resp_atri = dados.uuid_usu_atri;//uuid do atual usuário responsável pelo orçamento
      this.empresaAtribuida = (dados.uuid_emp_atribuicao == null) ? this.sessionService.getUUIDEmpresa() : dados.uuid_emp_atribuicao;//uuid da atual empresa responsável pelo orçamento
      this.empresaAtribuidaTipo = (dados.empresaatritipo == null) ? this.sessionService.getTipoEmpresa() : dados.empresaatritipo;//tipo da atual empresa responsável pelo orçamento
      let t;
      switch (this.empresaAtribuidaTipo) {//Converte qual o tipo de empresa que o orçamento atualmente pertence
        case 'CORPORATE': t = 'Associação'; break;
        case 'OFICINA': t = 'Oficina'; break;
        case 'REGULADORA': t = 'Reguladora'; break;
        default: t = null
      }
      this.resourceForm.get('usuarioEmpresa')?.setValue(t);//seta o tipo da atual empresa
      if (this.tipoEmpResp == 'OFICINA')
        this.resourceForm.get('empresa_resp')?.setValue(this.uuidEmpResp)//se o tipo da empresa for oficina o uuid da mesma ja é setado na empresa responsável
      this.onSelectTipoEmp(true);
      this.empresaSelecionada = t; //salva a empresa selecionada em uma variável
    })
  }
  onSelectEmp() {//função chamada ao selecionar a empresa destino do orçamento
    let tipo = this.resourceForm.get('usuarioEmpresa')?.value;//obtem o tipo da empresa destino
    let postData = {
      "method": "GET",
      "uuidOrcamento": this.uuid,
      "tipo_emp": tipo,
      "uuid": ((tipo == 'Associação') ? (this.uuidEmpOrcamento) : ((tipo == 0) ? this.uuidEmpResp : null))
    }//caso o tipo de empresa seja uma associação isso quer dizer que será atribuido à própria empresa selecionado, pois apenas associações podem atribuir à associações
    this.rest.getUsersByTipoEmpresa(postData).subscribe((data: any) => {//Obtem as empresas para o tipo de empresa selecionado
      if (data.mensagem != 'Empresa sem usuários registrados!') {//tratativa caso não haja empresas para o tipo de empresa selecionado
        this.responsaveis = []//limpa a lista caso ja tenha dados
        data.data.forEach((data) => {//obtem os dados e os coloca na lista para exibição ao usuário
          this.responsaveis.push({ "value": data.uuid_usuario, "label": ((data.fantasia == null || data.fantasia == '') ? this.nomeEmpResp : data.fantasia) + ' - ' + data.nome })
        })
        this.resourceForm.get('usuario')?.setValue('')//limpa o campo do usuário responsável
      }
      else this.responsaveis = []//caso não haja empresas cadastradas para o tipo selecionado a lista é limpa para evitar erro
    });
  }
  getTipoEmpresaAtual() {//Obter qual o tipo da empresa que o orçamento esta atribuido
    let tipo = this.tipoEmpResp//obtem o tipo da empresa dona do orçamento
    if (tipo != null && tipo != '') {//valida se o tipo de empresa do usuário logado não é nulo ou vazio
      if (tipo == 'CORPORATE') {//se for uma associação ela podera selecionar qualquer tipo de empresa para atribuir o orçamento
        this.responsavel = [//preenchimento dos tipos de empresa conforme regra
          { value: 'Associação', label: 'Perito' },
          { value: 'Oficina', label: 'Oficina' },
          { value: 'Reguladora', label: 'Reguladora' }
        ];
      }
      else if (tipo == 'OFICINA') {//se o tipo de empresa do usuário logado for uma oficina
        this.responsavel = [//as oficinas so podem atribuir aos usuário dela mesma, por isso temos apenas o valor de oficinas
          { value: 'Oficina', label: 'Oficina' }
        ];
        this.empresas = [//pelo fato da oficina so poder atribuir a ela mesma o valor referente à ela ja é definido
          { value: this.uuidEmpResp, label: this.nomeEmpResp }
        ]
        this.resourceForm.get('usuarioEmpresa')?.setValue('Oficina');
        this.resourceForm.get('empresa_resp')?.setValue(this.uuidEmpResp);
        this.habilitaTipo = false//trava a seleção do tipo de empresa, uma vez que oficina so pode atribuir à usuários dela própria
        this.onSelectTipoEmp();//faz chamada de funções de busca
        this.onSelectEmpresa();//para preencher os dados dos outros campos
      }
      else if (tipo == 'REGULADORA') {//se o tipo de empresa do usuário logado for reguladora
        this.responsavel = [//as reguladoras podem atribuir o orçamento para elas mesmas e para oficinas relacionadas às mesmas empresas que elas
          { value: 'Reguladora', label: 'Reguladora' },
          { value: 'Oficina', label: 'Oficina' }
        ];
        this.habilitaTipo = true
      }
      else {//tratativa caso o tipo da empresa não caiba dentro os itens acima
        this.responsavel = [
          { value: 'Associação', label: 'Perito' },
          { value: 'Oficina', label: 'Oficina' },
          { value: 'Reguladora', label: 'Reguladora' }
        ];
      }
    }
  }
  selectTodos(uuid) {
    if (uuid == this.sessionService.getUUIDEmpresa())
      return true
    return false
  }
  onSelectEmpresa(uuid = null, initial = false) {//função chamada ao selecionar a empresa destino do orçamento
    if (uuid == null)//prevensão de bug, para evitar que o uuid seja nulo
      uuid = this.resourceForm.get('empresa_resp')?.value;
    if (uuid != null) {//valida se o uuid é ou continua vazio
      this.rest.getUsuarioResponsavelUUIDEmp(uuid, this.selectTodos(uuid)).subscribe((data: any) => {//busca os usuário da empresa pelo uuid da empresa
        this.responsaveis = []//limpa lista de usuários
        if (data.data.status != 'erro' && data.data.length > 0) {//caso a API retorne sucesso com dados
          this.resourceForm.get('resp_orcamento')?.setValue(null)//limpa campo do usuário destino que estava anteriormente
          data.data.forEach((data) => {//preenche a lista com os dados retornados
            this.responsaveis.push({ "value": data.uuid_usuario, "label": data.nome })
          })
          let empresaSelec = this.resourceForm.get('usuarioEmpresa')?.value//obtem o tipo da empresa selecionado
          switch (this.tipoEmpResp) {//switch case usando o tipo da empresa dona do orçamento
            case ('CORPORATE'): {//para tipo de empresa destino igual à associação
              if (initial)//se for a primeira definição é definido conforme obteçao de dados inicial
                this.resourceForm.get('resp_orcamento')?.setValue(this.usu_resp_atri)
              else if (empresaSelec == 'Associação')//daso esteja atribuindo à um usuário da própria associação o valor é limpo
                this.resourceForm.get('resp_orcamento')?.setValue(null)
              else if (empresaSelec == 'Oficina')//caso seja uma oficina a empresa destino, o primeiro usuário ápito à receber o orçamento é setado
                this.resourceForm.get('resp_orcamento')?.setValue(data.data[0].uuid_usuario)
              else if (empresaSelec == 'Reguladora')// da mesma forma que oficina o primeiro usuário ápito é selecionado qnd a empresa destino for uma reguladora
                this.resourceForm.get('resp_orcamento')?.setValue(data.data[0].uuid_usuario)
              break;//para outros valores nada ocorre
            }
            case ('REGULADORA'): {//caso a empresa dona do orçamento seja uma reguladora
              if (empresaSelec == 'Oficina')//as reguladoras so podem atribuir para oficinas, por isso é selecionado o primeiro usuário ápito a receber o orçamento
                this.resourceForm.get('resp_orcamento')?.setValue(data.data[0].uuid_usuario)
              break;//para outros valores nada ocorre
            }
            default: null//para outros valores nada ocorre
          }
        }
        else {//caso não tenha usuários cadastrados ou a API retorne um erro é exibida a mensagem de erro
          this.resourceForm.get('empresa_resp')?.setValue(null);
          this.info.showErro('Não existem usuários na empresa selecionada!');
        }
      })
    }
    /* if (this.resourceForm.get('usuarioEmpresa')?.value == 'Oficina') {
      this.resourceForm.get('oficina')?.setValue(uuid)
    } */
  }
  retornaType(tipo) {//retorna a flag para consulta
    switch (this.tipoEmpResp) {
      case ('CORPORATE'): {
        if (tipo != 'Associação')
          return 'empresas_relacionadas';
        break;
      }
      case ('REGULADORA'): {
        if (tipo == 'Oficina')
          return 'empresas_relacionadas';
        break;
      }
      default: return null;
    }
  }
  onSelectTipoEmp(initial = false) {
    let tipo = this.resourceForm.get('usuarioEmpresa')?.value;//obtem o tipo de empresa selecionado
    if (this.tipoEmpResp != 'OFICINA') {//se o tipo for diferente de oficina o valor da empresa selecionado é limpo
      this.resourceForm.get('empresa_resp')?.setValue(null)
    }
    if (tipo == 0) {//flag usada para mostrar que não houve alteração
      switch (this.tipoEmpResp) {//tratativa para preenchimento inicial
        case 'OFICINA': this.empresaSelecionada = 'Oficina'; break;
        case 'REGULADORA': this.empresaSelecionada = 'Reguladora'; break;
        case 'CORPORATE': this.empresaSelecionada = 'Associação'; break;
        default: this.empresaSelecionada = 'Empresa'
      }
    }//preenche conforme o tipo
    else if (!(tipo == '' || tipo == null))
      this.empresaSelecionada = tipo
    else//tratativa caso passe por todas as etapas
      this.empresaSelecionada = 'Empresa'
    let postData = {
      "method": "GET",
      "uuidOrcamento": this.uuidEmpResp,
      "tipo_emp": tipo,
      "uuid": this.sessionService.getUUIDEmpresa(),//uuid da empresa do usuário logado
      "type": this.retornaType(tipo)
    }//monta body conforme seleção do tipo da empresa destino
    if (tipo != 'Associação' && this.tipoEmpResp == 'CORPORATE') {// caso a associação esteja vendo seu orçamento que esta atribuido à uma Reguladora ou Oficina
      this.rest.getUsersByTipoEmpresa(postData).subscribe((data: any) => {//obtem os dados caso a empresa logada seja uma associação porem queira atribuir à outra empresa
        //obtem empresas relacionadas
        this.resourceForm.get('resp_orcamento')?.setValue(null)//limpa valor de usuário final responsável para evitar erros
        if (data.data.mensagem != 'Empresa sem usuários registrados!') {//Verifica se a empresa possui usuários cadastrados
          this.empresas = [];//limpeza de lista
          this.valores = [];//limpeza de lista
          data.data.forEach((data) => {//preenche os dados das empresas conforme 
            this.empresas.push({ "value": data.uuid, "label": data.fantasia, "pintura": data.pintura, "troca": data.troca, "reparacao": data.reparacao, "montagem": data.montagem });
          })
          if ((this.empresaAtribuidaTipo == tipo.toUpperCase()) || data.data.length == 1) {
            this.resourceForm.get('empresa_resp')?.setValue((initial) ? this.empresaAtribuida : ((data.data.length == 1) ? data.data[0].uuid : null));
            if (initial || data.data.length == 1)
              this.onSelectEmpresa(((initial) ? this.empresaAtribuida : data.data[0].uuid), initial)
          }
        }
        else this.empresas = []; this.valores = [];
      });
    }
    else if (tipo == 'Associação' && this.tipoEmpResp == 'CORPORATE') {// caso a associação esteja vendo seu orçamento que foi atribuido à um usuário dela mesma
      this.empresas = [
        { "value": this.sessionService.getUUIDEmpresa(), "label": this.sessionService.getCurrentRazaoSocial() }
      ]
      this.resourceForm.get('empresa_resp')?.setValue(this.sessionService.getUUIDEmpresa());
      this.onSelectEmpresa(null, initial);
    }
    else if (tipo == 'Reguladora' && this.tipoEmpResp == 'REGULADORA') {
      this.empresas = [
        { "value": this.sessionService.getUUIDEmpresa(), "label": this.sessionService.getCurrentRazaoSocial() }
      ]
      this.resourceForm.get('empresa_resp')?.setValue(this.sessionService.getUUIDEmpresa());
      this.onSelectEmpresa(null, initial);
    }
    else if (tipo == 'Oficina' && this.tipoEmpResp == 'REGULADORA') {// para uma reguladora que tenha atribuido seu orçamento à uma oficina
      this.rest.getUsersByTipoEmpresa(postData).subscribe((data: any) => {
        if (data.data.mensagem != 'Empresa sem usuários registrados!') {
          this.empresas = [];
          this.valores = []
          //console.log(data)
          data.data.forEach((data) => {
            this.empresas.push({ "value": data.uuid, "label": data.fantasia });
            this.valores.push({ "pintura": data.pintura, "troca": data.troca, "reparacao": data.reparacao, "montagem": data.montagem });
          })
          //this.resourceForm.get('resp_oficina')?.setValue('')
        }
        else this.empresas = []; this.valores = []
      });
    }
    else {
      this.rest.getUsersByTipoEmpresa(postData).subscribe((data: any) => {
        if (data.mensagem != 'Empresa sem usuários registrados!') {
          this.responsaveis = []
          //console.log(data)
          //console.log(postData)
          if (data.data.length > 0) {
            data.data.forEach((data) => {
              this.responsaveis.push({ "value": data.uuid_usuario, "label": ((data.fantasia == null || data.fantasia == '' && this.tipoEmpResp != 'OFICINA') ? (this.nomeEmpResp == null) ? ' - ' + data.fantasia : ' - ' + this.nomeEmpResp : '') + data.nome });
              this.valores.push({ "pintura": data.pintura, "troca": data.troca, "reparacao": data.reparacao, "montagem": data.montagem });
            });
          }
          //this.resourceForm.get('resp_oficina')?.setValue('')
        }
        else this.responsaveis = []
      });
    }
    //this.checkDisplayResponsalvel()
  }
  checkDisplayResponsalvel() {
    if ((this.tipoEmpResp == 'OFICINA') || (this.tipoEmpResp == 'CORPORATE' && this.resourceForm.get('usuarioEmpresa')?.value == 'Associação') || (this.tipoEmpResp == 'REGULADORA' && this.resourceForm.get('usuarioEmpresa')?.value == 'Reguladora')) {
      return 'display: block;'
    }
    return 'display: none;'
  }

  //recalculo
  calcularHoraCentesimal(horaStr: string): number {
    let horaCentesimal = 0;
    if (horaStr && horaStr.indexOf(".")) {
      let hora: number = parseInt(horaStr.split('.', 2)[0]);
      let minHot: number = 0;
      if (horaStr.split('.', 2)[1] != null)
        minHot = parseInt(horaStr.split('.', 2)[1]) / 60.00;
      horaCentesimal = hora + minHot;
    } else {//hora já tá convertida
      horaCentesimal = parseFloat(horaStr);
    }
    return Number(horaCentesimal.toFixed(3));
  }
  onSubmit() {
    let resp = (this.resourceForm.get('resp_orcamento')?.value == 0 ? null : this.resourceForm.get('resp_orcamento')?.value);
    let tipo = this.resourceForm.get('usuarioEmpresa').value;
    if (resp != null) {//valida se há um usuário final responsável selecionado
      let tipoEmpAtual = this.sessionService.getTipoEmpresa();
      let status = null;
      let status2 = null;
      let status3 = null;
      if (tipoEmpAtual == 'REGULADORA') {
        status = 'AGUARDANDO';
        if (this.resourceForm.get('usuarioEmpresa')?.value == 'Oficina') {
          status2 = 'AGUARDANDO';
          status3 = 'PENDENTE';
        }
        else if (this.resourceForm.get('usuarioEmpresa')?.value == 'Reguladora') {
          status2 = 'Pendente';
        }
      }
      else if (tipoEmpAtual == 'Oficina') {
        status = 'AGUARDANDO';
        status3 = 'PENDENTE';
        if (this.temReguladora) {
          status2 = 'AGUARDANDO';
        }
      }
      else if (tipoEmpAtual == 'CORPORATE') {
        if (this.resourceForm.get('usuarioEmpresa')?.value == 'Associação') {
          status = 'PENDENTE'
        }
        else if (this.resourceForm.get('usuarioEmpresa')?.value == 'Reguladora') {
          status = 'AGUARDANDO';
          status2 = 'PENDENTE';
        }
        else if (this.resourceForm.get('usuarioEmpresa')?.value == 'Oficina') {
          status = 'AGUARDANDO';
          status3 = 'PENDENTE';
        }
      }

      let postData = {//monta body da requisição
        "uuidOrcamento": this.uuid,//identificador único do orçamento que será afetado
        "status": status ? status : this.status[0],//novo status do orçamento após a atribuição
        "status2": status2 ? status2 : this.status[1],//novo status do orçamento após a atribuição
        "status3": status3 ? status3 : this.status[2],//novo status do orçamento após a atribuição
        "flag": 'ATRIBUICAO',//flag para identificação no back
        "responsavel": (this.resourceForm.get('resp_orcamento')?.value == 0 ? null : this.resourceForm.get('resp_orcamento')?.value),
        //linha acima: identificador unico do usuário final responsável pelo orçamento
      }
      this.serv.salvarAtribuicao(postData).subscribe(//envia solicitação de alteração de usuário responsável do orçamento
        data => {
          var response = JSON.parse(JSON.stringify(data));
          if (response.status == 'success') {
            if (response.code == 1)
              if (tipo == 'Oficina') {// se a empresa destino da atribuição for uma oficina
                let empSelec = this.resourceForm.get('empresa_resp').value;
                if (empSelec != this.empresaAtribuida) {//valida se a oficina destino da atribuição é uma oficina diferente da oficina selecionada no momento do cadastro do orçamento
                  //caso a oficina selecionada seja diferente da selecionada no cadastro do orçamento o recalculo dos valores das peças será feito
                  let pintura, troca, remocao_instalacao, reparo;
                  for (let i = 0; i < this.empresas.length; i++) {
                    if (this.empresas[i].value == empSelec) {//obtem os valores das mão de obra dos serviços
                      pintura = this.empresas[i].pintura;
                      troca = this.empresas[i].troca;
                      remocao_instalacao = this.empresas[i].montagem;
                      reparo = this.empresas[i].reparacao;
                      break;
                    }
                  }
                  this.rest.getItensByUUID(this.uuid).subscribe((data: any) => {//obtem os itens do orçamento pelo uuid do orçamento
                    let dados: Array<any> = data.data;
                    if (dados.length != 0) {
                      let servico = [pintura, troca, remocao_instalacao, reparo];
                      let tipoServico = ['pintura', 'troca', 'remocao_instalacao', 'reparo'];//lista com os tipos de serviço pre-definidos
                      //declaração de variáveis que iram auxiliar no processo
                      let valor_hora;
                      let tempo;
                      let valor_servico = new Array;
                      let vAux;
                      let itens = new Array;
                      let vServicoAux;
                      let desconto, subtotal, liquido, bruto, uuidItem;
                      for (let i = 0; i < dados.length; i++) {//loop para passar por todos os itens do orçamento
                        vAux = new Object
                        vServicoAux = 0
                        for (let j = 0; j < tipoServico.length; j++) {//loop para passar por todos os tipos de orçamento pre-definidos
                          let aux = (dados[i][tipoServico[j] + "_tempo"])//obtem o tempo de mão de obra de um serviço
                          tempo = this.calcularHoraCentesimal((aux == '0' || aux == 'NaN') ? 0 : aux);//realiza a conversão do tempo
                          valor_hora = parseFloat(servico[j]);//obtem o valor da hora do serviço em questão
                          vAux[tipoServico[j] + '_valor_servico'] = parseFloat((valor_hora * tempo).toFixed(2));//obtem o valor do serviço
                          vAux[tipoServico[j] + '_valor_hora'] = valor_hora//obtem o valor da hora do serviço
                          vAux[tipoServico[j] + '_tempo'] = tempo//obtem o tempo do serviço
                          vServicoAux = parseFloat(vServicoAux) + parseFloat((valor_hora * tempo).toFixed(2));//realiza o calculo do valor total de todos os serviços
                        }
                        uuidItem = dados[i].uuid//obtem o uuid da peça
                        desconto = parseFloat(dados[i].valor_desconto);//obtem o valor do desconto da peça
                        subtotal = parseFloat(dados[i].valor_subtotal);//obtem o valor do subtotal da peça
                        bruto = parseFloat((subtotal + vServicoAux).toFixed(2));//obtem o valor bruto da peça
                        liquido = parseFloat((bruto * desconto / 100).toFixed(2));//obtem o valor liquido da peça
                        //realiza a inserção dos novos dados na lista
                        valor_servico[i] = vAux;
                        valor_servico[i].total_servico = vServicoAux;
                        valor_servico[i].desconto = desconto;
                        valor_servico[i].subtotal = subtotal;
                        valor_servico[i].bruto = bruto;
                        valor_servico[i].liquido = liquido;
                        valor_servico[i].uuid = uuidItem;
                      }
                      for (let i = 0; i < dados.length; i++) {//obtem os valores novos dos itens
                        itens.push({ "uuid": dados[i].uuid, "valores": valor_servico[i] })
                      }
                      let postData = {//monta o body da requisição
                        "uuidOrcamento": this.uuid,//identificador único do orçamento que será afetado
                        "itens": itens,//lista com os novos valores e identificador único da cada item do orçamento
                        'flag': 'mult',//flag para identificação no back
                        "type": 'valores'//segunda flag de identificação no back
                      }
                      this.rest.salvaValores(postData).subscribe((data: any) => { });//realiza a atualização dos valores
                    }
                  });
                }
              }
            //COMENTADO VERSIONAMENTO
            //let versao:number = Number(this.versaoVisual.replace(/[^0-9]/g,''));
            let versao;
            if (this.versao == -1) {
              versao = 'V1.0';
            } else {
              let v1 = String(this.versao_visual).split('.')[0];
              versao = v1 + '.' + this.versao;
            }
            //let versao = "V1.0";//seta valor da versão vizual do orçamento
            if (this.heGerarVersao())
              this.rest.criarVersao(this.protocolo, versao).subscribe((dataV: any) => {//realiza a solicitação do versionamento
                if (dataV.status == 'success' || dataV.code == '404') {//valida se a criação da versão foi bem sucedida
                  var response = JSON.parse(JSON.stringify(dataV));
                  if (response.status == 'success') {
                    this.bsModalRef.hide();//fecha modal de atribuição
                    this.comu.filter('closed-atribuicao');//envia flag para tela de listagem de orçamentos para realizar atualização
                  }
                }
              });
            else {
              this.bsModalRef.hide();//fecha modal de atribuição
              this.comu.filter('closed-atribuicao');//envia flag para tela de listagem de orçamentos para realizar atualização
            }
          }
        }
      );
    }
    else {//caso o usuário responsável não seja definido é exibida uma mensagem de erro
      this.info.showErro('Usuário não encontrado!');
    }
  }

  heGerarVersao(): boolean {
    let empresaSelect = this.resourceForm.get('usuarioEmpresa').value;
    if (this.empresaAtribuidaTipo == 'CORPORATE' && empresaSelect == 'Associação')
      return false;
    if (this.empresaAtribuidaTipo == 'REGULADORA' && empresaSelect == 'Reguladora')
      return false;
    if (this.empresaAtribuidaTipo == 'OFICINA' && empresaSelect == 'Oficina')
      return false;
    return true;
  }
}